// src/components/Sidebar.jsx

import React from "react";
import styled from "styled-components";
import { NavLink } from "react-router-dom";

const SidebarContainer = styled.nav`
  width: 250px;
  position: sticky;
  top: 63px;
  height: calc(100vh - 63px);
  overflow-y: auto;
  background-color: transparent;
  border-right: 2px solid #2f2f2f;
  padding: 0px 30px;
  box-sizing: border-box;

  /* Custom scrollbar styles (WebKit-based browsers) */
  &::-webkit-scrollbar {
    width: 8px;           /* scrollbar width */
  }

  &::-webkit-scrollbar-track {
    background: #fff; /* makes the track (background) transparent */
  }

  &::-webkit-scrollbar-thumb {
    background-color: #3c8c42; /* color of the scrolling handle (thumb) */
    border-radius: 4px;        /* roundness of the thumb */
  }

  /* Optional: Hover effect on thumb */
  &::-webkit-scrollbar-thumb:hover {
    background-color: #45a049;
  }

  /* For Firefox (not part of styled-components but for your reference) */
scrollbar-width: thin;
scrollbar-color: #3c8c42 transparent; /* thumb color, track color */
`;

const SidebarTitle = styled.h3`
  color: #45a049;
  margin-bottom: 20px;
`;

/**
 * Use NavLink to style an active link differently.
 */
const SidebarLink = styled(NavLink)`
  display: block;
  margin-bottom: 10px;
  color: #aaaaaa;
  text-decoration: none;
  font-size: 0.9rem;
  transition: color 0.3s;

  &:hover {
    color: #45a049;
  }

  &.active {
    color: #45a049;
  }
`;

const Sidebar = () => {
  return (
    <SidebarContainer>
      <SidebarTitle>Docs</SidebarTitle>
      <SidebarLink to="/docs/getting-started">Getting Started</SidebarLink>
      <SidebarLink to="/docs/installation">Installation</SidebarLink>
      {/* Add more links as needed */}
      {/* For testing overflow, duplicate or add more links here */}
    </SidebarContainer>
  );
};

export default Sidebar;
